import { render, staticRenderFns } from "./RequestLogStatusBadge.vue?vue&type=template&id=d13a374a"
import script from "./RequestLogStatusBadge.vue?vue&type=script&lang=js"
export * from "./RequestLogStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports